import { initialize } from '@execonline-inc/resourceable.private';
import Fetch from '../Fetch/Init';
import type { Rel } from '../Resource/Types';
import Schema from './Schema';

export default initialize<Rel, typeof Schema.endpoints>(Schema.endpoints, Fetch);
